export const getWindowHostname = (): string => {
  return window.location.hostname;
};
